import { STACK, SORT, StackOptionType, SortOptionType, SortKeyType } from 'types/deck'

export type QueryParams = {
  sort?: string
  stack?: string
  commanderAs?: string
  noClear?: boolean
}

export const calculateStack = (queryParamStack = ''): StackOptionType | null => {
  const stack = STACK[queryParamStack.toUpperCase()]

  return stack !== undefined ? stack : null
}

export const calculateSort = (queryParamSort = ''): SortOptionType | null => {
  const sort = SORT[queryParamSort.toUpperCase() as SortKeyType]

  return sort !== undefined ? sort : null
}
